import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { ConsolidationComponent } from './pages/consolidation/consolidation.component';
import { ProvisionalControlComponent } from './pages/provisional-control/provisional-control.component';
import { CaseComponent } from '../cases/pages/case/case.component';
import { tenantRouteGuard } from 'src/app/tenant-config/tenant-route.guard';

const routes: Routes = [
   {
      path: '',
      redirectTo: 'agenda',
      pathMatch: 'full'
   },
   {
      path: 'agenda',
      component: ScheduleComponent,
      data: { breadcrumb: 'Agenda' }
   },

   { path: 'agenda/:providerId', component: ScheduleComponent },

   {
      path: 'consolidacion',
      component: ConsolidationComponent,
      canActivate: [tenantRouteGuard],
      data: {
         breadcrumb: 'Consolidación',
         tenantRoute: '/app/gestion/consolidacion',
      }
   },
   {
      path: 'control-prestacional',
      component: ProvisionalControlComponent,
      canActivate: [tenantRouteGuard],
      data: {
         breadcrumb: 'Control Prestacional',
         tenantRoute: '/app/gestion/control-prestacional',
      }
   },
   {
      path: 'control-prestacional/:id',
      component: CaseComponent,
      canActivate: [tenantRouteGuard],
      data: {
         breadcrumb: 'Control Prestacional >:id',
         tenantRoute: '/app/gestion/control-prestacional/:id',
      }
   },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule],
})
export class ScheduleRoutingModule { }
